<template>
    <div class="side-menu">
        <div class="logo-block">
            <img src="../assets/img/logo.png" />
        </div>
        <div class="menu-block">
            <ul class="menu-block-ul">
                <li>
                    <router-link class="mn-link" to="/">
                        <span class="mn-icon"
                            ><i class="bi bi-android2"></i
                        ></span>
                        <span class="mn-link-text">Боты</span>
                    </router-link>
                </li>
                <li>
                    <router-link class="mn-link" to="/sender">
                        <span class="mn-icon"
                            ><i class="bi bi-send-plus"></i
                        ></span>
                        <span class="mn-link-text">Создать рассылку</span>
                    </router-link>
                </li>
                <li>
                  <router-link class="mn-link" to="/broadcast_status">
                          <span class="mn-icon"
                          ><i class="bi bi-clock-history"></i
                          ></span>
                    <span class="mn-link-text">Статус рассылок</span>
                  </router-link>
                </li>
                <li>
                  <router-link class="mn-link" to="/projects">
                            <span class="mn-icon"
                            ><i class="bi bi-kanban"></i
                            ></span>
                    <span class="mn-link-text">Проекты</span>
                  </router-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Nav',
}
</script>
